import React from 'react'
import { withI18next } from 'lib/i18n/withI18next'
import compose from 'recompose/compose'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Typo from 'constants/typography'
import { hasLocizeTranslation } from 'lib/utils/locize'
import styles from './product-available-sizes.scss'

const ProductAvailableSizes = ({ t, attributes, is_coming_soon }) => (
  <React.Fragment>
    <style jsx>{styles}</style>
    <div className={clsx(Typo.caption, 'product-available-sizes')}>
      <span>
        {hasLocizeTranslation(t, 'PDP_SIZES_AVAILABLE', 'Sizes available:')}
      </span>
      {attributes.map((attribute, index) => {
        const isLast = attributes.length - 1 === index

        return (
          <div
            key={attribute?.id_product_attribute}
            className={clsx({
              'product-available-sizes__disabled':
                attribute?.stock?.is_sold_out && !is_coming_soon,
            })}
          >
            {isLast ? attribute?.size : `${attribute?.size},`}
          </div>
        )
      })}
    </div>
  </React.Fragment>
)

ProductAvailableSizes.defaultProps = {
  attributes: [],
  is_coming_soon: false,
}

ProductAvailableSizes.propTypes = {
  t: PropTypes.func.isRequired,
  is_coming_soon: PropTypes.bool,
  attributes: PropTypes.arrayOf(
    PropTypes.shape({
      size: PropTypes.string,
      stock: PropTypes.shape({
        is_sold_out: PropTypes.bool,
      }),
      id_product_attribute: PropTypes.number,
    }),
  ),
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
  })),
  withI18next(),
)(ProductAvailableSizes)
